import Profile from "../assets/icons/profile";
import QuestionRounded from "../assets/icons/question-rounded";
import Document from "../assets/icons/document";
import CheckRounded from "../assets/icons/check-rounded";
import HomeIcon from "../assets/icons/home-icon";

import Login from "../views/Login";
import SignIn from "../views/SignIn";
import PasswordRecovery from "../views/PasswordRecovery";
import CredentialsExpired from "../views/CredentialsExpired";
import Faq from "../views/Faq";
import Home from "../views/Home";
import PillsList from "../views/PillsList";
import Account from "../views/Account";
import PvList from "../views/PvList";
import CheckList from "../views/CheckList";
import CheckListForm from "../views/CheckListForm";
import Error from "../views/Error";
import NavigateAs from "../views/NavigateAs";
import Notifications from "../views/Notifications";
import MoodleAuthorization from "../views/MoodleAuthorization";
import AuthCode from "../views/AuthCode";
import ChangePassword from "../views/ChangePassword";
import Documents from "../views/Documents";
import CrownRounded from "../assets/icons/crown-rounded";
import Shop from "../assets/icons/shop";
import PvStats from "../views/PvStats";
import AddPuntoVendita from "../views/AddPuntoVendita";


export const permissions = [
  {
    label: "Log-in",
    icon: null,
    href: "/login",
    permission: ["ALL"],
    permission_ad:["ALL"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: true,
    component: <Login />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "Codice autenticazione",
    icon: null,
    href: "/auth-code",
    permission: ["ALL"],
    permission_ad:["ALL"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: true,
    component: <AuthCode />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "Registrati",
    icon: null,
    href: "/sign-in",
    permission: ["ALL"],
    permission_ad:["ALL"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <SignIn />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "Recupero password",
    icon: null,
    href: "/password-recovery",
    permission: ["ALL"],
    permission_ad:["ALL"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <PasswordRecovery />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "Aggiorna credenziali",
    icon: null,
    href: "/credentials-expired",
    permission: ["ALL"],
    permission_ad:["ALL"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <CredentialsExpired />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "FAQ",
    icon: <QuestionRounded size={22} color="#858597" className="ms-auto" />,
    href: "/faq",
    permission: ["ALL"],
    permission_ad:["ALL"],
    exclude_to_menu_for: [],
    is_menu_area: true,
    is_index: false,
    component: <Faq />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Home",
    icon: <HomeIcon size={23} color="#858597" className="ms-auto" />,
    href: "/",
    permission: ["ADMIN", "DM", "AM", "RCR", "GESTORE","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: true,
    is_index: false,
    component: <Home />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Cambia password",
    icon: null,
    href: "/change-password",
    permission: ["DM", "AM", "RCR", "GESTORE"],
    permission_ad:[],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <ChangePassword />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Verifica sessione moodle",
    icon: null,
    href: "/sso/authorize",
    permission: ["ADMIN", "DM", "AM", "RCR", "GESTORE","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <MoodleAuthorization />,
    redirect_session: "/",
    is_frame_parent: true,
    impersonated_area_navigable: true,
  },
  {
    label: "Lista pillole formative",
    icon: null,
    href: "/pills-list",
    permission: ["ADMIN", "DM", "AM", "RCR", "GESTORE","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <PillsList />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Account",
    icon: <Profile size={27} color="#858597" className="ms-auto" />,
    href: "/account",
    permission: ["ADMIN", "DM", "AM", "RCR", "GESTORE","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: true,
    is_index: false,
    component: <Account />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "Checklist",
    icon: <CheckRounded size={29} color="#858597" className="ms-auto" />,
    href: "/pv-list",
    permission: ["ADMIN", "DM", "AM", "RCR","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: true,
    is_index: false,
    component: <PvList />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Dettagli punti vendita",
    icon: <Shop size={22} color="#858597" className="ms-auto" />,
    href: "/pv-stats",
    permission: ["ADMIN", "DM", "AM", "RCR", "GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: true,
    is_index: false,
    component: <PvStats />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "Lista valutazioni per pv",
    icon: null,
    href: "/check-list",
    permission: ["ADMIN", "DM", "AM", "RCR","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <CheckList />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Questionario valutazione pv",
    icon: null,
    href: "/check-list-form",
    permission: ["ADMIN", "DM", "AM", "RCR","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <CheckListForm />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Documenti",
    icon: <Document size={26} color="#858597" className="ms-auto" />,
    href: "/documents",
    permission: ["ADMIN", "DM", "AM", "RCR", "GESTORE","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: true,
    is_index: false,
    component: <Documents />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Notifiche",
    icon: null,
    href: "/notifications",
    permission: ["ADMIN", "DM", "AM", "RCR", "GESTORE","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <Notifications />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Naviga come...",
    icon: <CrownRounded size={24} color="#858597" className="ms-auto" />,
    href: "/navigate-as",
    permission: ["ADMIN","GUEST","TAS"],
    permission_ad: ["ADMIN","GUEST","TAS"],
    exclude_to_menu_for: [],
    is_menu_area: true,
    is_index: false,
    component: <NavigateAs />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: false,
  },
  {
    label: "Pagina non trovata",
    icon: null,
    href: "*",
    permission: ["ALL"],
    permission_ad:["ALL"],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <Error />,
    redirect_session: null,
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
  {
    label: "Aggiungi Punto Vendita",
    icon: null,
    href: "/add-puntovendita",
    permission: ["GESTORE"],
    permission_ad:[],
    exclude_to_menu_for: [],
    is_menu_area: false,
    is_index: false,
    component: <AddPuntoVendita />,
    redirect_session: "/",
    is_frame_parent: false,
    impersonated_area_navigable: true,
  },
];
